module.exports = __webpack_public_path__ + "img/s2_stepimg01@2x.a3c3c87b.png";